import { useTranslation } from "react-i18next";
import React, { useRef, useState } from "react";
import AuthLayout from "../../layouts/AuthLayout";
import ButtonLong from "../../components/ButtonLong";
import TextInput from "../../components/TextInput";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";
import { apollo } from "../../utils/apollo";
import { useMutation } from "react-query";
import { REQUEST_PASSWORD_RESET } from "../../utils/graphql";
function ResetPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const recaptcha = useRef();
  const requestPasswordResetMutation = useMutation({
    mutationFn: async () => {
      const { data } = await apollo.mutate({
        mutation: REQUEST_PASSWORD_RESET,
        variables: {
          input: {
            email,
          },
        },
      });
      return data?.requestPasswordReset;
    },
    onError: (error) => {
      if (error.graphQLErrors) {
        error.graphQLErrors.map((item) => console.log(item));
      }
    },
    onSuccess: async (data) => {
      if (data) {
        if (data.message) {
          toast.success(data.message);
        }
        setTimeout(() => {
          window.location.href = process.env.REACT_APP_GAID_URL + `/logout`;
        }, 5000);
      } else {
        toast.error("Something went wrong!");
      }
    },
    onSettled: async () => {
      recaptcha?.current?.reset();
    },
  });
  const resetPasswordHandler = async (e) => {
    e.preventDefault();
    const captcha = recaptcha.current?.getValue();
    if (!captcha) {
      toast.error("Please verify the reCAPTCHA!");
      return;
    }
    requestPasswordResetMutation.mutate();
  };
  return (
    <AuthLayout
      title={t("Reset your account password")}
      subtitle={
        <>
          {t("Already signed up?")}{" "}
          <Link
            to="/login"
            className="font-semibold leading-6 text-primary-600 hover:text-primary-500"
          >
            {t("Go ahead and log in.")}
          </Link>
        </>
      }
    >
      <form className="space-y-6" action="#" method="POST">
        <TextInput
          label={t("Email address")}
          get={email}
          set={setEmail}
          id="email"
          name="email"
          type="email"
          required={true}
        />

        <div className="flex justify-center">
          <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_SITE_KEY} />
        </div>
        <div>
          <ButtonLong
            onClick={resetPasswordHandler}
            disabled={requestPasswordResetMutation.isLoading}
          >
            {t("Reset")}
          </ButtonLong>
        </div>
      </form>
    </AuthLayout>
  );
}
export default ResetPassword;
